import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GlobalStateContext } from "../../utils/GlobalStateContext";
import { Home, Heart, QrCode, CreditCard, UserPlus, Shield, LogOut, FlaskConical, ClipboardPlus, CalendarClock } from 'lucide-react';
import { toast } from "react-toastify";
import health_guardian from '../../img/health_guardian.webp';
import QuickLabOrderModal from './QuickLabOrderModal';
import { performLogout } from '../../utils/logout';

export default function TopBar() {
    const { currentPatient, setCurrentUser, setCurrentPatient } = useContext(GlobalStateContext);
    const navigate = useNavigate();
    const [labModalOpen, setLabModalOpen] = useState(false);

    // Ends the server-side session as well as the Firebase one — see utils/logout.js.
    const handleLogout = async () => {
        await performLogout();
        setCurrentUser?.(null);
        setCurrentPatient?.(null);
        navigate('/login', { replace: true });
    };

    const handlePatientRequired = (path) => {
        if (!currentPatient) {
            toast.error('No patient selected. Please search for and select a patient first.');
            return;
        }
        navigate(path);
    };

    return (
        <>
            <div className="home-topbar">
                <div className="home-topbar-brand">
                    <img src={health_guardian} alt="Health Guardian" className="home-topbar-logo" />
                    <h1 className="home-topbar-title">Health Guardian</h1>
                </div>
                <div className="home-topbar-actions">
                    {/* <Link to="/labs" className="topbar-btn">
                        <FlaskConical size={15} />
                        <span>Labs</span>
                    </Link>
                    <button className="topbar-btn" onClick={() => setLabModalOpen(true)}>
                        <ClipboardPlus size={15} />
                        <span>Quick Lab Order</span>
                    </button> */}
                    <Link to="/ctContrastConsent" className="topbar-btn">
                        <Heart size={15} />
                        <span>Contrast Consent</span>
                    </Link>
                    <Link to="/barcode" className="topbar-btn">
                        <QrCode size={15} />
                        <span>Barcode</span>
                    </Link>
                    <button className="topbar-btn" onClick={() => handlePatientRequired('/hgiPayments')}>
                        <CreditCard size={15} />
                        <span>Payments</span>
                    </button>
                    {/* <Link to="/orderImaging" className="topbar-btn">
                        <UserPlus size={15} />
                        <span>Referred Intake</span>
                    </Link> */}
                    <Link to="/availability" className="topbar-btn">
                        <CalendarClock size={15} />
                        <span>Availability</span>
                    </Link>
                    <Link to="/adminDashboard" className="topbar-btn danger">
                        <Shield size={15} />
                        <span>Admin</span>
                    </Link>
                    <button className="topbar-btn logout" onClick={handleLogout}>
                        <LogOut size={15} />
                        <span>Log Out</span>
                    </button>
                </div>
            </div>
            <QuickLabOrderModal isOpen={labModalOpen} onClose={() => setLabModalOpen(false)} />
        </>
    );
}
